<template>
  <div class="">
    <van-nav-bar
      title="注册"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- <div class="tab">
      <ul>
        <li @click="changecolour">
          公司
          <div :class="{ di: dis }"></div>
        </li>
        <li @click="changecolour2">
          个体工商户
          <div :class="{ di: !dis }"></div>
        </li>
      </ul>
    </div> -->
    <div
      class=""
      style="height:0.3rem"
    ></div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="username"
        name="username"
        label="昵称"
        placeholder="请填写昵称"
        :rules="[{ required: true, message: '请填写公司名称或经营者名称' }]"
      />
      <van-field
        v-model="mobile"
        name="mobile"
        label="手机号"
        placeholder="请输入手机号"
        @change="panduanm"
        :rules="[{ required: true, message: '请输入手机号' }]"
      />
      <van-field
        name="check1"
        v-model="checkcode"
        center
        clearable
        label="图形验证码"
        placeholder="请输入图形验证码"
       
      >
        <template #button>
          <img @click="get" style="width: 3rem;" :src="cimg" alt="">
        </template>
      </van-field>
      <van-field
        name="check"
        v-model="sms"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
        :rules="[{ required: true, message: '请输入短信验证码' }]"
      >
        <template #button>
          <van-button
            size="small"
            type="primary"
            native-type="button"
            @click="timego"
            :disabled="but"
          >{{ timetxt }}</van-button>
        </template>
      </van-field>
   
      <van-field
        v-model="password"
        type="password"
        name="password"
        label="密码"
        placeholder="请填写六位数密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />
      <!-- <van-field
        v-model="confirm"
        type="password"
        name="confirm"
        label="确认密码"
        placeholder="确认密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      /> -->

      <van-field
        readonly
        clickable
        name="shop"
        :value="value"
        label="店铺选择"
        placeholder="点击选择店铺"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择店铺' }]"
      />
      <van-popup
        v-model="showPicker"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="columns"
          value-key="1"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />

      </van-popup>
      <van-field
        readonly
        clickable
        name="telephone"
        v-show="telephone"
        :value="telephone+' (可点击拨打询问)'"
        label="该店铺电话"
        @click="gotelephone(telephone)"
      />
      <van-field
        readonly
        clickable
        name="recommend"
        :value="recommends"
        label="业务员"
        placeholder="点击选择销售人员(选填)"
        @click="showPicker2 = true"
      />
      <van-popup
        v-model="showPicker2"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="columns2"
          @confirm="onConfirm2"
          @cancel="showPicker2 = false"
        />
      </van-popup>
      <!-- <van-field
        v-model="address"
        type="text"
        name="address"
        label="您的详细地址"
        placeholder="请填写详细地址(选填)"
      /> -->
      <!-- <van-field
        v-model="mailbox"
        type="text"
        name="mailbox"
        label="邮箱"
        placeholder="请输入邮箱(选填)"
      /> -->
      <van-field
        name="uploader_img"
        label="营业执照上传"
        :rules="[{ required: true, message: '请上传营业执照' }]"
      >
        <template #input>
          <van-uploader
            max-size="113122150"
            accept="image/*"
            @oversize="oversize"
            :after-read="afterRead"
            v-model="fileList"
            max-count="1"
          />
        </template>
      </van-field>

      <div class="checkbox">
        <van-checkbox
          v-model="checked"
          :label-disabled="true"
        >
          我以阅读并同意<span @click="goagreement">《用户协议》</span><span @click="goagreement1">《隐私政策》</span></van-checkbox>
      </div>
      <div style="margin: 16px;">
        <van-button
          round
          block
          type="info"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from 'vue'
import areaList from '../../../assets/area'

import {
  NavBar,
  Button,
  Uploader,
  Field,
  Form,
  Checkbox,
  CheckboxGroup,
  Toast,
  Picker,
  Popup,
  Area, Dialog
} from 'vant'
Vue.use(NavBar)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Form)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Toast).use(Picker).use(Popup).use(Area).use(Dialog)
export default {
  created () {
    // console.log(this.$store.state.address)

    // this.id = this.$route.params.id /creimgcode
    this.axios.get("getAllStore", { params: { city: this.$store.state.address } }).then(res => {
      // console.log(res)
      res.data.data.listall.forEach(v => {
        this.columns.push(v.store_name)
        this.columnsid.push(v.store_id)
      })
      if (res.data.data.current.store_name) {
        this.value.push('')
        this.value = res.data.data.current.store_name
        this.shopid = res.data.data.current.store_id
      }

    }).catch(ref => {
      console.log(ref)
    })
  
  },
  data () {
    return {
      petname: '',
      username: '',
      password: '',
      confirm: '',
      mobile: '',
      recommend: '', //
      address: '',
      mailbox: '',
      tlist: ["个人", "个体工商户", "个人独资企业", "有限责任公司"],
      tslist: ["个人经营定税", "小规模纳税人", "一般纳税人"],
      fileList: [],
      sms: '',
      dis: true,
      checked: false,
      time: 60,
      shopid: '',
      recommendid: '',
      timetxt: '发送验证码',
      but: false,
      value: "",
      recommends: '',
      tax: '',
      columns: [],
      columnsid: [],
      columns2: [],
      columns2id: [],
      showPicker: false,
      showPicker2: false,
      showPicker3: false,
      showPicker4: false,
      types: "",
      area: '',
      showArea: false,
      areaList, // 数据格式见 Area 组件文档
      userfalg: true,
      mobilefalg: true,
      imgfalge: false,
      wz: '',
      telephone: '',
      yz: '',
      cimg: '',
      checkcode:''
    }
  },
  watch: {

  },
  methods: {
    // up (e) {
    //   let file = e.target.files[0];
    //   // console.log(e.target.name)
    //   var param = new FormData(); // 创建form对象
    //   param.append("image", file, file.name);
    //   console.log(param)
    //   this.axios.post('uploadCertificate', param, {
    //     headers: { "Content-Type": "multipart/form-data" }
    //   }).then(res => {
    //     console.log(res)
    //   }).catch(ref => {
    //     console.log(ref)
    //   })
    // },
    gotelephone (i) {
      Dialog.confirm({
        title: '电话客服',
        message: i,
        confirmButtonText: '呼叫'
      })
        .then(() => {
          // on confirm
          window.location.href = "tel:" + i
        }).catch(() => { })
    },
    panduan () {
      // console.log(1)
      if (this.username.trim() == "") {
        Toast("名称不能为空")
      } else {
        this.axios.post("usernameIsResiter", { username: this.username.trim() }).then(res => {
          if (res.data.code == 400) {
            Toast(res.data.msg)
            this.userfalg = false
          } else {
            this.userfalg = true
          }
        }).catch(ref => {
          console.log(ref)
        })
      }
    },
    panduanm () {
      // console.log(1)
      this.get()
      if (this.mobile) {
        if (/^1[23456789]\d{9}$/.test(this.mobile)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      } else {
        Toast('请输入手机号')
        return
      }
      this.axios.post("mobileIsResiter", { mobile: this.mobile }).then(res => {
        if (res.data.code == 400) {
          Toast(res.data.msg)
          this.mobilefalg = false
        } else {
          this.mobilefalg = true

        }
      }).catch(ref => {
        console.log(ref)
      })
    },
    onArea (values) {
      this.area = values.map((item) => item.name).join('/');
      this.showArea = false;
    },
    onConfirm (value, i) {
      this.axios.get("getAllSalers/" + this.columnsid[i]).then(res => {
        this.columns2 = []
        this.recommends = ''
        this.telephone = res.data.data.store_info.store_mobile
        res.data.data.sale_info.forEach(v => {
          this.columns2.push(v.name)
          this.columns2id.push(v.id)
        })
      }).catch(ref => {
      })
      this.value = value;
      this.shopid = this.columnsid[i]
      this.showPicker = false;

    },
    onConfirm2 (value, i) {
      this.recommends = value;
      this.recommendid = this.columns2id[i]
      this.showPicker2 = false;
    },
    onConfirm3 (value, i) {
      this.types = value;
      this.showPicker3 = false;
    },
    onConfirm4 (value, i) {
      this.tax = value;
      this.showPicker4 = false;
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onSubmit (v) {
      // console.log(v)
      if (this.userfalg) { } else {
        Toast('该名称已被注册')
        return
      }
        if (this.mobilefalg) { } else {
          Toast('该手机已被注册')
          return
        }
      // if (this.imgfalge) { } else {
      //   Toast('请上传营业执照')
      //   return
      // }
      if (v.username.trim() == '') {
        Toast('名称请勿输入空格')
        return
      } else if (v.password.length < 6) {
        Toast('密码至少六位')
        return
      } 
      // else if (v.password != v.confirm) {
      //   Toast('两次输入密码不一致')
      //   return
      // } 
      else if (!this.checked) {
        Toast('请先阅读《用户协议》,《隐私政策》')
        return
      } else {
        // console.log('ok')
      }
      v.shop = this.shopid
      v.recommend = this.recommendid
      v.uploader_img = this.yz
      console.log(v)
      // return false
      this.axios.post("register", v).then(res => {
      
        if (res.data.code == 200) {
          Toast(res.data.msg)
          this.$router.push('login')
        }else {
          Toast(res.data.msg)
        }
      }).catch(ref => {
        console.log(ref)
      })

    },

    changecolour () {
      this.dis = true
    },
    changecolour2 () {
      this.dis = false
    },
    goagreement () {
      this.$router.push('agreement')
    },
 goagreement1 () {
      this.$router.push('agreement1')
    },
    timego () {
      if (this.mobile) {
        if (/^1[23456789]\d{9}$/.test(this.mobile)) {
        } else {
          Toast('请输入正确手机号')
          return
        }
      } else {
        Toast('请输入手机号')
        return
      }
      if (this.checkcode) { } else { 
        Toast('请输入图形验证码')
        return

      }
      this.axios.post("sendnewsmscode", { mobile: this.mobile,source:'hkjreg',checkcode:this.checkcode }).then(res => {
        if (res.data.code == 200) {
         
        Toast('发送成功')
        this.but = true
        var timer = setInterval(() => {
          this.time--
          this.timetxt = '请' + this.time + '秒后发送'
          if (this.time === 0) {
            this.but = false
            clearInterval(timer)
            this.time = 60
            this.timetxt = '发送验证码'
          }
        }, 1000)
      }else {
          Toast(res.data.msg)
        this.get()
      }

      }).catch(ref => {
        console.log(ref)
      })

    },
    oversize () {
      Toast('请上传10m之内的图片')

    },
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append('image', file.file)
      console.log(1)
      this.axios.post('uploadCertificate', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        file.status = 'done';
        this.yz = res.data.path
        this.imgfalge = true

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
    get () {
      this.axios.post("creimgcode", {source:'hkjreg',phone:this.mobile  }).then(res => {
      // console.log(res)
      this.cimg=res.data.data.base64_image 

    }).catch(ref => {
      console.log(ref)
    })
    }
  },
  components: {},
}
</script>


<style lang="less" scoped>
.top {
  width: 100%;
  height: 0.2rem;
}

.tab {
  ul {
    li {
      float: left;
      width: 50%;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      .di {
        width: 2rem;
        height: 0.3rem;
        background-color: #a22d2b;
        margin: 0 auto;
      }
    }
  }
}
.checkbox {
  padding-top: 0.5rem;
  padding-left: 10%;
  span {
    color: #f00;
  }
}
.van-cell__value {
  overflow: auto;
}
</style>
